import React, { useEffect } from "react";
import { useState } from "react";

const Map = ({ propertyData }) => {
  const [address, setAddress] = useState(
    propertyData.address ? 
    propertyData.address.replace(/,/g, "").replace(/ /g, "+") :
    `${propertyData.street || ""} ${propertyData.street_2 || ""} ${propertyData.city || ""} ${propertyData.state || ""} ${propertyData.zipcode || ""}`.replace(/ /g, "+")
  );
  // const [address, setAddress] = useState(
  //   "address" in propertyData && propertyData.address
  //     ? propertyData.address.replace(/ /g, "+")
  //     : `${propertyData.street ? propertyData.street : ""} ${
  //         propertyData.city ? propertyData.city : ""
  //       } ${propertyData.state ? propertyData.state : ""} ${
  //         propertyData.zipcode ? propertyData.zipcode : ""
  //       }`.replace(/ /g, "+")
  // );

  // useEffect(() => {
  //   if ("address" in propertyData && propertyData.address) {
  //     // getting address from MLS
  //     setAddress(propertyData.address.replace(/ /g, "+"));
  //   } else if (
  //     ("street" in propertyData && propertyData.street) ||
  //     ("city" in propertyData && propertyData.city) ||
  //     ("state" in propertyData && propertyData.state) ||
  //     ("zipcode" in propertyData && propertyData.zipcode)
  //   ) {
  //     // fetch from normal db address
  //     var strAddress = "";
  //     strAddress =
  //       strAddress + "street" in propertyData && propertyData.street
  //         ? propertyData.street
  //         : "";
  //     strAddress =
  //       strAddress + "city" in propertyData && propertyData.city
  //         ? propertyData.city
  //         : "";
  //     strAddress =
  //       strAddress + "state" in propertyData && propertyData.state
  //         ? propertyData.state
  //         : "";
  //     strAddress =
  //       strAddress + "zipcode" in propertyData && propertyData.zipcode
  //         ? propertyData.zipcode
  //         : "";

  //     setAddress(strAddress);
  //   } else {
  //     // do not load map
  //   }
  // }, []);

  // console.log("--- maps: ", address);

  // console.log("propertyData: ", propertyData);

  return (
    <>
      {address && address.length ? (
        <iframe
          width="100%"
          height="450"
          // height="100%"
          style={{ border: "0" }}
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          src={`https://www.google.com/maps/embed/v1/place?key=${
            import.meta.env.VITE_GOOGLE_MAPS_API_KEY
          }&q=${address}`}
        ></iframe>
      ) : (
        <></>
      )}
    </>
  );
};

export default Map;
